import React, { PureComponent } from 'react';
import { Route, Switch } from 'react-router-dom';
import AuditLogsList from './AuditLogsList';

class AuditLogs extends PureComponent {
  render() {
    return (
      <Switch>
        <Route exact path="/dashboard/auditLogs" component={AuditLogsList} />
      </Switch>
    );
  }
}

export default AuditLogs;
